import { UseQueryOptions } from '@tanstack/react-query';
import { CuredApiPaths } from 'models/enums';
import useQuery from '../useQuery';
import QueryKeys from './keys';
import type { AccessCentreRolesApiResponse } from 'domains/accessCentre/types';

const DEFAULT_LIMIT = 10;
const DEFAULT_OFFSET = 0;

type UseGetRolesListParams = {
    limit?: number;
    offset?: number;
    searchTerm?: string;
    reactQueryOptions?: UseQueryOptions<AccessCentreRolesApiResponse, Error>;
};

const useGetRolesList = ({
    limit = DEFAULT_LIMIT,
    offset = DEFAULT_OFFSET,
    searchTerm,
    reactQueryOptions,
}: UseGetRolesListParams = {}) => {
    const queryKey = QueryKeys.ACCESS_CENTRE_ROLES(limit, offset, searchTerm);
    const params: { limit: number; offset: number; search?: string } = { limit, offset };
    if (searchTerm?.trim()) {
        params.search = searchTerm.trim();
    }
    const axiosOptions = { params };

    return useQuery<AccessCentreRolesApiResponse>(
        queryKey,
        CuredApiPaths.ACCESS_CENTRE_ROLES,
        reactQueryOptions,
        axiosOptions
    );
};

export default useGetRolesList;
